export default "__VITE_ASSET__jq5IUK5R__"